/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import Feature from '@modules/utils/feature'
import withRouter from '@modules/routing/withRouter'

import { getCurrentUser } from '@/reducers/currentUser'
import { fetchCurrentUserRequest } from '@/reducers/asyncRequests/registry'

import { getConfigForKey, isFeatureActivated } from '../../../../selectors'
import { createDeploymentUrl, deploymentGettingStartedUrl } from '../../../../lib/urlBuilder'

import App from './App'

import type { ReduxState } from '@/types/redux'
import type { ConsumerProps, StateProps } from './types'

const mapStateToProps = (
  state: ReduxState,
  { router: { location, params } }: ConsumerProps,
): StateProps => {
  const deploymentId = params.deploymentId

  return {
    requireEula: isFeatureActivated(state, Feature.eula),
    currentUser: getCurrentUser(state),
    pollingInterval: getConfigForKey(state, `POLLING_INTERVAL`),
    fetchCurrentUserRequest: fetchCurrentUserRequest(state),
    isCreateUrl: location.pathname === createDeploymentUrl(),
    isGettingStartedUrl: Boolean(
      deploymentId && location.pathname === deploymentGettingStartedUrl(deploymentId),
    ),
    isSaasAdminconsole: getConfigForKey(state, `CLOUD_UI_APP`) === `saas-adminconsole`,
  }
}

export default withRouter(connect<StateProps, null, ConsumerProps>(mapStateToProps)(App))
